import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import Footer from "../components/Footer";
import "./CategoryPage.css";

const BASE = "https://storage.googleapis.com/rasai-nutrie-assets/products/coffee";

const coffees = [
  { id: "coffee-peppermint", name: "Peppermint Coffee",  price: 99,  size: "30g", image: `${BASE}/peppermint.png` },
  { id: "coffee-hibiscus",   name: "Hibiscus Coffee",    price: 105, size: "30g", image: `${BASE}/hibiscus.png` },
  { id: "coffee-blackgrape", name: "Black Grape Coffee", price: 102, size: "30g", image: `${BASE}/blackgrape.png` },
  { id: "coffee-chamomile",  name: "Chamomile Coffee",   price: 102, size: "30g", image: `${BASE}/chamomile.png` },
  { id: "coffee-plums",      name: "Plums Coffee",       price: 112, size: "30g", image: `${BASE}/plums.png` },
  { id: "coffee-beetroot",   name: "Beetroot Coffee",    price: 104, size: "30g", image: `${BASE}/beetroot.png` },
];

const CoffeePage = () => (
  <div className="category-page">
    <div className="category-hero" style={{ backgroundImage: `url(${BASE}/banner.png)` }}>
      <div className="category-hero-overlay">
        <Link to="/products" className="category-back">← All Categories</Link>
        <h1 className="category-hero-title">COFFEE</h1>
        <p className="category-hero-sub">Botanical blends · Rich flavour · RASAI nutrie</p>
      </div>
    </div>
    <div className="category-body category-body--video">
      <video className="category-bg-video" src={`${BASE}/background.mp4`} autoPlay loop muted playsInline />
      <div className="category-grid category-grid--4">
        {coffees.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
    <Footer />
  </div>
);

export default CoffeePage;
